import { render } from "./PhotopeaEditor.vue?vue&type=template&id=5ccf2d0a&scoped=true"
import script from "./PhotopeaEditor.vue?vue&type=script&lang=js"
export * from "./PhotopeaEditor.vue?vue&type=script&lang=js"

import "./PhotopeaEditor.vue?vue&type=style&index=0&id=5ccf2d0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ccf2d0a"]])

export default __exports__